/**
 * Created by JIA on 2020/9/19.
 * A panel that you can collapse/expand if its content is to long
 */
import React, { forwardRef, useImperativeHandle, useState } from "react";
import PropTypes from "prop-types";
import { ScrollView, Text, TouchableOpacity, View } from "react-native";
import FAIcon from "react-native-vector-icons/FontAwesome5";
import _ from "lodash";
import { withTranslation } from "react-i18next";
import UIDs from "../../UIDs";
import UnitStyle from "../../screens/course/units/UnitStyle";

import Dimensions from "react-native-web-dimension-helper";

const uid = UIDs.components.ui.collapsiblePanel;

const windowHeight = Dimensions.get("window").height;

const CollapsiblePanel = forwardRef((props, ref) => {
    //const scrollViewRef = useRef(null);
    const [expanded, setExpanded] = useState(true);
    //if we use view as container, at first we should not set height for it
    // otherwise the height will be abnormal
    const [layoutInit, setLayoutInit] = useState(false);
    const [canExpand, setCanExpand] = useState(false);
    const [contentHeight, setContentHeight] = useState(_.isNumber(props.maxHeight) && props.maxHeight > 0 ? props.maxHeight : 0);

    const onChildrenLayout = ({ nativeEvent }) => {
        const { height } = nativeEvent.layout;
        setContentHeight(height); //store the real Height
        if (_.isNumber(props.maxHeight) && props.maxHeight > 0) {
            if (height > props.maxHeight) {
                if (!props.expanded)
                    setExpanded(false);
                setCanExpand(true);
            } else {
                setExpanded(true);
                setCanExpand(false);
            }
        }
        setLayoutInit(true);
    };

    /*const _onContentSizeChange = (width, height) => {
        //console.log(height);
        setContentHeight(height); //store the real Height
        if (_.isNumber(props.maxHeight) && props.maxHeight > 0) {
            if (height > props.maxHeight) {
                setExpanded(false);
                setCanExpand(true);
            } else {
                setExpanded(true);
                setCanExpand(false);
            }
        }
    };*/

    const toggleExpand = newExpand => {
        if (newExpand === undefined) {
            newExpand = !expanded;
        }
        if (canExpand) {
            setExpanded(newExpand);
            //when expand, we need scroll the scrollview to the top
            // if (scrollViewRef.current && newExpand) {
            //     scrollViewRef.current.scrollTo({ x: 0, y: 0, animated: true });
            // }
        }
    };

    const _handleExpandContent = () => {
        const newExpand = !expanded;
        toggleExpand(newExpand);
    };

    //extract toggleExpand as this component ref method, let you can control expand outside the component
    useImperativeHandle(ref, () => ({
        toggleExpand: newExpand => {
            toggleExpand(newExpand);
        },
        canExpand: canExpand,
        expanded: expanded,
    }));

    //only can scroll when canExapnd and expanded
    // const canScroll = canExpand ? !expanded : false;
    //need to set the overflow style when enable scroll and expanded
    // const scrollOverflowStyle = canScroll ? styles.collapseScrollViewStyle : styles.expandScrollViewStyle;
    //console.log(canScroll);
    return (
        <View style={[styles.containerStyle, props.style]}>
            {props.children ? (
                <>
                    <View style={[layoutInit ? { maxHeight: expanded ? contentHeight : props.maxHeight, overflow: "hidden" } : null]}>
                        <ScrollView
                            {...props}
                            scrollEnabled={props.scrollEnabled}
                            //nestedScrollEnabled={canScroll} // handle nest scroll view case
                            //onContentSizeChange={_onContentSizeChange}
                            contentContainerStyle={[styles.flexGrow1, props.scrollViewContentContainerStyle]}
                            automaticallyAdjustContentInsets={false}
                            removeClippedSubviews={false}
                            //ref={scrollViewRef}
                            style={[styles.flexGrow1, props.scrollViewStyle, { maxHeight: expanded ? props.scrollMaxHeight : null }]}
                        >
                            <View onLayout={onChildrenLayout}>{props.children}</View>
                        </ScrollView>
                    </View>
                    <View style={[UnitStyle.dividingLine]} />
                </>
            ) : null}
            {canExpand ? (
                <TouchableOpacity style={[styles.expandButtonContainerStyle, props.expandButtonContainerStyle]} onPress={_handleExpandContent}>
                    <Text style={[styles.expandButtonTextStyle, props.expandButtonContainerStyle]}>{props.t(expanded ? "collapse" : "expand")}</Text><FAIcon name={expanded ? "angle-up" : "angle-down"} size={22} style={[styles.expandButtonStyle, props.expandButtonContainerStyle]} />
                </TouchableOpacity>
            ) : null}
        </View>
    );
});

CollapsiblePanel.propTypes = {
    ...ScrollView.propTypes,
    maxHeight: PropTypes.number, //if height > max height , show expand button and shrink
    expandButtonContainerStyle: PropTypes.object,
    expandButtonStyle: PropTypes.object,
    expandButtonTextStyle: PropTypes.object,
    scrollViewStyle: PropTypes.object,
    scrollViewContentContainerStyle: PropTypes.object,
    scrollEnabled: PropTypes.bool,
    scrollMaxHeight: PropTypes.number, //define scroll max height on expanded
};

CollapsiblePanel.defaultProps = {
    maxHeight: windowHeight * 0.32,
    scrollEnabled: false,
    scrollMaxHeight: windowHeight * 0.64,
};

const styles = {
    expandButtonContainerStyle: { justifyContent: "center", alignItems: "center", flexDirection: "row" },
    expandButtonStyle: { color: "#5CADFF" },
    expandButtonTextStyle: { color: "#5CADFF", fontSize: 15, marginRight: 5 },
    flexGrow1: { flexGrow: 1 },
    containerStyle: {
        /*flex: 1*/
    },
    expandScrollViewStyle: { overflow: "visible" },
    collapseScrollViewStyle: { overflow: "scroll" },
};

export default withTranslation(uid, { withRef: true })(CollapsiblePanel);
